import { BaseModel } from "model/BaseModel";
import CteEmitente from "./CteEmitente";
import CteRemetente from "./CteRemetente";
import CteDestinatario from "./CteDestinatario";
import { CteDadosComplementares } from "./CteDadosComplementares";
import CteTomador from "./CteTomador";
import CteInfNfe from "./CteInfNfe";
import CteIcms from "./CteIcms";
import CteItemCarga from "./CteItemCarga";
import CteVPrest from "./CteVPrest";
import CteInfCarga from "./CteInfCarga";

export default class Cte implements BaseModel{

    id: number | null;
    codigo: string | null = null;
    chCte: string;
    versao: string;
    cUF: number;
    cCT: number;
    cfop: number;
    natOp: string;
    mod: number;
    serie: string;
    nct: number;
    dhEmi: Date | null;
    tpImp: number;
    tpEmis: number;
    cDV: number;
    tpAmb: number;
    tpCte: number;
    procEmi: number;
    verProc: string;
    cmunEnv: number;
    xmunEnv: string;
    ufenv: string;
    modal: string;
    tpServ: number;
    cmunIni: number;
    xmunIni: string;
    ufini: string;
    cmunFim: number;
    xmunFim: string;
    ufFim: string;
    retira: number;
    xDetRetira: string;
    indIEToma: number;
	qrcode: string;
	RNTRC: string;
	dhRecbto: Date | null;
	nProt: number;
	cStat: number;
	toma: number;
    emitente: CteEmitente | null;
    remetente: CteRemetente | null;
    destinatario: CteDestinatario | null;
	tomador: CteTomador | null;
	icms: CteIcms | null;
	infCarga: CteInfCarga | null;
	vPrest: CteVPrest | null;
	dadosComplementares: CteDadosComplementares | null;
	listInfNfe: CteInfNfe[];

    constructor(
        id: number | null = null,
        chCte: string = "",
        versao: string = "",
        cUF: number = 0,
        cCT: number = 0,
        cfop: number = 0,
        natOp: string = "",
        mod: number = 0,
        serie: string = "",
        nct: number = 0,
        dhEmi: Date | null = null,
        tpImp: number = 0,
        tpEmis: number = 0,
        cDV: number = 0,
        tpAmb: number = 0,
        tpCte: number = 0,
        procEmi: number = 0,
        verProc: string = "",
        cmunEnv: number = 0,
        xmunEnv: string = "",
        ufenv: string = "",
        modal: string = "",
        tpServ: number = 0,
        cmunIni: number = 0,
        xmunIni: string = "",
        ufini: string = "",
        cmunFim: number = 0,
        xmunFim: string = "",
        ufFim: string = "",
        retira: number = 0,
        xDetRetira: string = "",
        indIEToma: number = 0,
        qrcode: string = "",
        RNTRC: string = "",
        dhRecbto: Date | null = null,
        nProt: number = 0,
        cStat: number = 0,
        toma: number = 0,
        emitente: CteEmitente | null = null,
        remetente: CteRemetente | null = null,
        destinatario: CteDestinatario | null = null,
        tomador: CteTomador | null = null,
        icms: CteIcms | null = null,
        infCarga: CteInfCarga | null = null,
        vPrest: CteVPrest | null = null,
        dadosComplementares: CteDadosComplementares | null = null,
        listInfNfe: CteInfNfe[] = []
    ) {
        this.id = id;
        this.chCte = chCte;
        this.versao = versao;
        this.cUF = cUF;
        this.cCT = cCT;
        this.cfop = cfop;
        this.natOp = natOp;
        this.mod = mod;
        this.serie = serie;
        this.nct = nct;
        this.dhEmi = dhEmi;
        this.tpImp = tpImp;
        this.tpEmis = tpEmis;
        this.cDV = cDV;
        this.tpAmb = tpAmb;
        this.tpCte = tpCte;
        this.procEmi = procEmi;
        this.verProc = verProc;
        this.cmunEnv = cmunEnv;
        this.xmunEnv = xmunEnv;
        this.ufenv = ufenv;
        this.modal = modal;
        this.tpServ = tpServ;
        this.cmunIni = cmunIni;
        this.xmunIni = xmunIni;
        this.ufini = ufini;
        this.cmunFim = cmunFim;
        this.xmunFim = xmunFim;
        this.ufFim = ufFim;
        this.retira = retira;
        this.xDetRetira = xDetRetira;
        this.indIEToma = indIEToma;
        this.qrcode = qrcode;
        this.RNTRC = RNTRC;
        this.dhRecbto = dhRecbto;
        this.nProt = nProt;
        this.cStat = cStat;
        this.toma = toma;
        this.emitente = emitente;
        this.remetente = remetente;
        this.destinatario = destinatario;
        this.tomador = tomador;
        this.icms = icms;
        this.infCarga = infCarga;
        this.vPrest = vPrest;
        this.dadosComplementares = dadosComplementares;
        this.listInfNfe = listInfNfe;
    }
    
}



